// import { Layout } from "antd";
// import React from "react";
// import { Outlet } from "react-router-dom";
// import Sidebar from "./sidebar";
// // import Sidebar from "./sidebar/Sidebar";

// const { Content, Sider } = Layout;
// const MainLayout = () => {
//   return (
//     <Layout style={{ height: "100vh", overflow: "hidden" }}>
//       <Sider
//         width={220}
//         style={{
//           background: "#fff",
//           borderRight: "1px solid #eee",
//         }}
//       >
//         <Sidebar />
//       </Sider>
//       <Layout
//         style={{
//           padding: "20px 30px 20px",
//           backgroundColor: "#fefefe",
//           gap: "20px",
//           overflow: "auto",
//         }}
//       >
//         <Content>
//           <Outlet />
//         </Content>
//       </Layout>
//     </Layout>
//   );
// };

// export default MainLayout;

import { Layout } from "antd";
import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./sidebar";

const { Content, Sider } = Layout;

export default function MainLayout() {
  return (
    <Layout className="app-shell">
      <Sider width={280} className="app-sider" theme="light">
        <Sidebar />
      </Sider>

      <Layout className="app-main">
        <Content className="app-content">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
